import React from 'react';
import { Band } from './Band';
import { atsBlocks } from '../../data/site';
export function WhyNotATS() {
  return <Band dark id="independence" eyebrow="Why an ATS can't build this" title="The system that made the shortlist can't audit the shortlist." description="Independence is not a feature an applicant tracking system can simply add. The system making the hiring decision cannot also be the independent evidence layer used to examine that decision." data-id="element-410" data-mp="21xblauyd3wwj">
      <div className="grid gap-4 lg:grid-cols-3" data-id="element-411" data-mp="1eb55hmip5cvr">
        {atsBlocks.map((block, i) => <article key={block.title} className="flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-8" data-id="element-412" data-mp="1j96o66c7na6p" data-mpi={i}>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-teal-light" data-id="element-413" data-mp="14cz18y9f3unq">
              {String(i + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-5 font-display text-2xl font-light text-bone" data-id="element-414" data-mp="2ypx9lcbk4h8f">
              {block.title}
            </h3>
            <p className="mt-4 max-w-[46ch] text-[15px] leading-relaxed text-bone/65" data-id="element-415" data-mp="33lmfdxe66ud6">
              {block.body}
            </p>
          </article>)}
      </div>

      <p className="mt-10 max-w-[80ch] font-display text-2xl font-light leading-snug text-bone" data-id="element-416" data-mp="2l9z9xp6slni9">
        Lentic sits outside the hiring workflow to create an independent
        evidence layer: what the candidate was given, what the AI produced,
        what the candidate verified, what they missed, and what a human
        ultimately decided.
      </p>
    </Band>;
}